import { render, staticRenderFns } from "./LgsDashboardIndex.vue?vue&type=template&id=4ac0c896&"
import script from "./LgsDashboardIndex.vue?vue&type=script&lang=js&"
export * from "./LgsDashboardIndex.vue?vue&type=script&lang=js&"
import style0 from "./LgsDashboardIndex.vue?vue&type=style&index=0&id=4ac0c896&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports